import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'

import './styles.css'

class LocationDates extends Component {

  static propTypes = {
    tripId: PropTypes.string.isRequired,
    locationId: PropTypes.string.isRequired,
    tripData: PropTypes.shape({
      events: PropTypes.arrayOf(
        PropTypes.shape({
          depart: PropTypes.string,
          arrive: PropTypes.string,
          start: PropTypes.bool,
          end: PropTypes.bool,
        })
      ),
    }).isRequired,
    updateTripLocation: PropTypes.func.isRequired,
  }

  state = {
    arrivalDate: '',
    validationMsg: '',
    minArrivalDate: '',
    maxArrivalDate: '',
  }

  componentWillMount() {
    this.setStateFromProps({ props: this.props, })
  }

  componentWillReceiveProps(nextProps) {
    this.setStateFromProps({ props: nextProps, })
  }

  setStateFromProps = ({ props, }) => {
    const { tripData, locationId, } = this.props
    let locationIndex = -1
    tripData.events.forEach((event, index) => {
      if (event.id === locationId) {
        locationIndex = index
      }
    })
    const thisLocation = tripData.events[locationIndex]
    const nextLocation = tripData.events[locationIndex + 1]
    const prevLocation = tripData.events[locationIndex - 1]
    // const location = tripData.events.filter(event => event.id === locationId)[0]
    // debugger
    // console.log({ thisLocation, nextLocation, prevLocation })

    const arrivalDate = thisLocation.arrive || thisLocation.depart
    const validationMsg = ''
    const minArrivalDate = _.get(prevLocation, 'arrive', undefined)
    const maxArrivalDate = _.get(nextLocation, 'arrive', undefined)

    this.setState({
      arrivalDate,
      validationMsg,
      minArrivalDate,
      maxArrivalDate,
    })
  }

  handleChange = (event) => {
    let isValid = true
    let validationMsg
    const { minArrivalDate, maxArrivalDate, } = this.state
    const newDate = event.target.value
    // validation checks
    if (maxArrivalDate && moment(newDate).isAfter(moment(maxArrivalDate))) {
      isValid = false
      validationMsg = `new date cannot be later than ${maxArrivalDate}`
    }
    if (minArrivalDate && moment(newDate).isBefore(moment(minArrivalDate))) {
      isValid = false
      validationMsg = `new date cannot be before ${minArrivalDate}`
    }
    if (!isValid) {
      this.setState({
        validationMsg,
      })
    } else {
      this.setState({
        arrivalDate: newDate,
      })
    }
  }

  saveChanges = () => {
    // tripId, location, to,
    const { arrivalDate, } = this.state
    const { tripId, tripData, locationId, updateTripLocation, } = this.props
    const locationData = tripData.events.filter(location => location.id === locationId)[0]
    const location = _.cloneDeep(locationData)
    // for now we just tweak the arrival date (will leave 'to' modifications for another day)
    location.arrive = arrivalDate
    updateTripLocation({
      tripId,
      location,
    })
  }

  render() {
    const { handleChange, saveChanges, } = this
    const { arrivalDate, validationMsg, } = this.state

    return (
      <div>
        <input
          type="date"
          className="location-date"
          name="location-date"
          value={arrivalDate}
          onChange={handleChange}
        />
        {validationMsg}
        {!validationMsg && <button onClick={saveChanges}>Save</button> }
      </div>
    )
  }
}

export default LocationDates



// WEBPACK FOOTER //
// ./src/components/EditTrip/LocationDates/component.js